<template>
  <div>
    <p>Loading...</p>
    {{ error }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: ''
    }
  },
  methods: {
    handleLoginEvent(data) {
      if (!data.error) {
        this.$router.push(data.state.target || "/");
      }
    },
  },
  created() {
    this.$auth.handleAuthentication().then(() => {})
    .catch(err => { this.error = err.errorDescription });
  }
};
</script>
